import React from "react";
import StyledSelect from "../../components/StyledSelect";

export function CustomizationSelectors({
  vm,
  styles,
}) {
  const {
    isAdmin,
    clients,
    selectedClient,
    setSelectedClient,
    bots,
    selectedBot,
    setSelectedBot,
    effectiveClientId,
  } = vm;

  return (
    <>
      {isAdmin && (
        <div style={styles.clientSelector}>
          <label style={styles.label}>Cliente:</label>
          <StyledSelect
            value={selectedClient}
            onChange={setSelectedClient}
            options={[
              { value: "", label: "Selecione um cliente" },
              ...clients.map((client) => ({ value: client.id, label: client.name })),
            ]}
            placeholder="Selecione um cliente"
          />
        </div>
      )}

      {effectiveClientId && (
        <div style={styles.clientSelector}>
          <label style={styles.label}>Bot:</label>
          <StyledSelect
            value={selectedBot}
            onChange={setSelectedBot}
            options={[
              { value: "", label: "Selecione o bot para personalizar" },
              ...bots.map((b) => ({
                value: b.id || b._id,
                label: b.name || b.id || b._id,
              })),
            ]}
            placeholder="Selecione o bot"
            disabled={!bots.length}
          />
        </div>
      )}
    </>
  );
}
